"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSearchType = void 0;
var LocationSearchType;
(function (LocationSearchType) {
    LocationSearchType["DEFAULT"] = "default";
    LocationSearchType["CUSTOM_SEARCH"] = "custom-search";
    LocationSearchType["SHARE_MY_LOCATION"] = "share-my-location";
})(LocationSearchType || (exports.LocationSearchType = LocationSearchType = {}));
//# sourceMappingURL=ClickAndCollectEnums.js.map